export const DeliciousThemeContext = {
  PBanner: require('./Banner.scss'),
  PButton: require('./Button.scss'),
  PButtonGroup: require('./ButtonGroup.scss'),
  PConnected: require('./Connected.scss'),
  PDisplayText: require('./DisplayText.scss'),
  PIcon: require('./Icon.scss'),
  PLabel: require('./Label.scss'),
  PLabelled: require('./Labelled.scss'),
  PMessage: require('./Message.scss'),
  PModal: require('./Modal.scss'),
  PPagination: require('./Pagination.scss'),
  PPicker: require('./Picker.scss'),
  PPopoverPicker: require('./PopoverPicker.scss'),
  PSelect: require('./Select.scss'),
  PSideNavigation: require('./SideNavigation.scss'),
  PSpinner: require('./Spinner.scss'),
  PTextField: require('./TextField.scss')
};
